import { OrdersService } from '@services/orders.service';
import { UiService } from '@services/ui.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from '@classes/user/user';

export interface DialogData {
  orderId: string,
  drivers: User[];
  commentDriver: string;
  driverToAssign: string;
}

@Component({
  selector: 'app-dialog-assign-driver',
  templateUrl: './dialog-assign-driver.component.html',
  styleUrls: ['./dialog-assign-driver.component.scss']
})
export class DialogAssignDriverComponent implements OnInit {

  driverForm = new UntypedFormGroup({
    driver: new UntypedFormControl('', Validators.required),
    comment: new UntypedFormControl('')
  });

  constructor(
    public dialogRef: MatDialogRef<DialogAssignDriverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private uiSrv: UiService,
    private ordersSrv: OrdersService
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

  confirmDriverChange(): void {
    this.ordersSrv.assignDriver(this.data.orderId, this.driverForm.value.driver, this.driverForm.value.comment)
      .subscribe(() => {
        this.uiSrv.showSnackbar('orders.edit.reassigned', true);
        //   this.order.driver = this.driverForm.value.driver;
        //   this.order.status = 4;
        //   this.showDrivers = false;
        // });
        this.onNoClick();
      })

  }

}
